import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";

import AuthLayout from "../../components/layout/AuthLayout";

const UpdatePasswordSuccess = (): JSX.Element => {
  return (
    <AuthLayout
      title="Password Updated Successfully!"
      subTitle="You can go back to login page and login with your new credentials."
      isThankYou
      isLoginPages
    >
      <Link className="link-btn" to="/">
        Back To Login?
      </Link>
    </AuthLayout>
  );
};

export default withRouter(UpdatePasswordSuccess);
